"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EncoreProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _EncoreContext = require("../../contexts/EncoreContext.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * EncoreProvider is a recommended wrapper allowing you to opt certain components into new features
 * and other future breaking changes, without waiting for the next major Encore version.
 * You can also use EncoreProvider to render to a deprecated version, or test out new experimental features.
 *
 * [Encore site](https://encore.spotify.net/web/components/encore-context) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/EncoreProvider)
 */
var EncoreProvider = exports.EncoreProvider = function EncoreProvider(_ref) {
  var config = _ref.config,
    children = _ref.children;
  var keyedConfig = _objectSpread(_objectSpread({}, _EncoreContext.EncoreContextDefault), config);
  return /*#__PURE__*/_react["default"].createElement(_EncoreContext.EncoreContext.Provider, {
    value: keyedConfig
  }, children);
};